var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useState } from 'react';
import { accountApi } from '../../api/common/account';
var AvailablePerksContext = createContext(null);
var AvailablePerksProvider = React.memo(function (_a) {
    var children = _a.children;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(null), availablePerks = _c[0], setAvailablePerks = _c[1];
    var _d = useState(false), bypassAvailableState = _d[0], setBypassAvailableState = _d[1];
    var _e = useState(!isLoading && !!(availablePerks === null || availablePerks === void 0 ? void 0 : availablePerks.errors)), hasError = _e[0], setHasError = _e[1];
    var refreshData = function () {
        setHasError(false);
        setIsLoading(true);
    };
    var finishLoading = React.useCallback(function (perksData) {
        if (perksData && (perksData === null || perksData === void 0 ? void 0 : perksData.availablePerks) === 0)
            setBypassAvailableState(true);
        setIsLoading(false);
    }, []);
    var getPerksAvailableData = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var perksData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (![null, '', undefined].includes(availablePerks === null || availablePerks === void 0 ? void 0 : availablePerks.availablePerks)) return [3 /*break*/, 2];
                    return [4 /*yield*/, accountApi
                            .perksAvailableDetails()
                            .then(function (data) {
                            if (data === null || data === void 0 ? void 0 : data.errors)
                                return setHasError(true);
                            return data;
                        })
                            .catch(function () { return setHasError(true); })];
                case 1:
                    perksData = _a.sent();
                    setAvailablePerks(perksData);
                    finishLoading(perksData);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, []);
    return (React.createElement(AvailablePerksContext.Provider, { value: React.useMemo(function () { return ({
            hasError: hasError,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            availablePerks: availablePerks,
            getPerksAvailableData: getPerksAvailableData,
            bypassAvailableState: bypassAvailableState,
            finishLoading: finishLoading,
            refreshData: refreshData,
        }); }, [isLoading]) }, children));
});
export { AvailablePerksProvider, AvailablePerksContext };
